// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7d548089","239":"16feb0fe","667":"e425e361","722":"494e391a"}[chunkId] + ".chunk.js";
};